module.exports = __webpack_public_path__ + "img/close_cross_circle.162a9d82.svg";